// extracted by mini-css-extract-plugin
export default {"markdownDisplay":"MarkdownDisplay_markdownDisplay__brHMe"};